import React from 'react';
import { Trans } from 'react-i18next';
import { Text } from '@adc/parallax-component-library';
import { useDefaultTransComponents } from 'Hooks';
import i18n from 'Utilities/i18n';
const RichText = ({ text, values = {}, onPressLink, customNodes, testID, ...rest }) => {
    const defaultTransComponents = useDefaultTransComponents(onPressLink, customNodes);
    return (React.createElement(Trans, { i18n: i18n, defaults: text, values: values, parent: ({ children }) => (React.createElement(Text, { testID: testID, color: "$text.100", fontSize: "$bodyBase.default", fontWeight: "$bodyBase.default" }, children)), components: defaultTransComponents, ...rest }));
};
export { RichText };
